import { TrifoldMapIcon } from "../../../icons";
import { useDeliveryFlowStore } from "../../../store/newVehicleDeliveryStore";

export const ServiceOptions = () => {
  // Step One: Here the user chooses the types of services
  // he/she wants to book an appointment for.

  // GLOBAL STATE
  const isVehicleDeliverySelected = useDeliveryFlowStore((s) => s.isVehicleDeliverySelected);
  const setIsVehicleDeliverySelected = useDeliveryFlowStore((s) => s.setIsVehicleDeliverySelected);
  const hasVehicleHomeDelivery = useDeliveryFlowStore((s) => s.hasVehicleHomeDelivery);
  const deliveryCosts = useDeliveryFlowStore((s) => s.deliveryCosts);
  const apiOptions = useDeliveryFlowStore((s) => s.apiOptions);
  const deliveryLocation = useDeliveryFlowStore((s) => s.deliveryLocation);
  const hasOnlyCalendar = useDeliveryFlowStore((s) => s.hasOnlyCalendar);

  // LOCAL STATE:

  // FETCH DATA:

  // LOCAL VARIABLES:
  
  // USE EFFECTS:

  // HANDLERS & FUNCTIONS:

  return (
    <div className={`grid ${hasOnlyCalendar ? "grid-cols-1" : "grid-cols-2"}  gap-3 h-[198px] max-lg:grid-cols-1`}>
      {!hasOnlyCalendar && <div className={`bg-white flex flex-col gap-2 w-full p-6 border ${apiOptions?.includes("HomeDelivery") && 'cursor-pointer'} ${!hasVehicleHomeDelivery ? 'border-fadedgrey' : isVehicleDeliverySelected ? "outline outline-1 outline-[#070707] border-[#070707]" : "border-fadedgrey"} rounded-xl`}
        onClick={()=> {
          if(apiOptions?.includes("HomeDelivery") && hasVehicleHomeDelivery){
            setIsVehicleDeliverySelected(true)
          }
        }
        }>
        <div className='flex flex-row justify-between items-start gap-4'>
          <p className={`text-lg font-bold ${!apiOptions?.includes("HomeDelivery") && !hasVehicleHomeDelivery && 'text-fadedgrey'}`}>Home Delivery</p>
          <div className={`flex justify-center items-center w-[73px] h-[26px] ${deliveryCosts?.[0]?.amount > 0 ? "bg-[#D4002A]" : "bg-mildgrey"}  text-white font-medium text-sm px-2 py-1 rounded-[4px]`}>
            {deliveryCosts?.[0]?.amount === 0 ? "ΔΩΡΕΑΝ" : `${deliveryCosts?.[0]?.amount}€`}
          </div>
        </div>
        <p className={`text-sm ${!apiOptions?.includes("HomeDelivery") && !hasVehicleHomeDelivery && 'text-fadedgrey'}`}>Παραδίδουμε το νέο σου αυτοκίνητο στον χώρο που σε εξυπηρετεί, την ημέρα και ώρα που θα επιλέξεις.</p>
      </div>}
      <div className={`bg-white flex flex-col gap-2 justify-between w-full p-6 border ${apiOptions?.includes("GarageDelivery") && 'cursor-pointer'} ${isVehicleDeliverySelected ? "border-fadedgrey" : "outline outline-1 outline-[#070707] border-[#070707]" } rounded-xl`}
        onClick={()=> {
          if(apiOptions?.includes("GarageDelivery")){
            setIsVehicleDeliverySelected(false)
          }
        }}>
        <div>
          <p className={`text-lg font-bold pb-2 ${!apiOptions?.includes("GarageDelivery") && 'text-fadedgrey'}`}>Παραλαβή από εγκαταστάσεις Avis</p>
          <p className={`text-sm ${!apiOptions?.includes("GarageDelivery") && 'text-fadedgrey'}`}>Παραλαμβάνεις το νέο σου αυτοκίνητο την ημέρα και ώρα που θα επιλέξεις από τις εγκαταστάσεις Avis {deliveryLocation?.address}, {deliveryLocation?.city}.</p>
        </div>
        <button 
          className='bg-none flex flex-row gap-2 items-center mt-2' 
          onClick={()=>{window.open(deliveryLocation?.googleMapsURL, "_blank", "noopener,noreferrer");}}>
            <TrifoldMapIcon className={`w-4 h-4 text-primary`} />
            <p className={`text-sm text-primary font-semibold`}>Δες το στον χάρτη</p>
        </button>
      </div>
    </div>
  );
};